import React from "react";
import CloseModalIconSVG from "../../assets/icons/svg/CloseModalIconSVG";
import BaseButton from "../Buttons/BaseButton";
import { ButtonVariantEnum } from "../../utils/enums/ButtonVariantEnum";

const AddImagesModal = ({
    open,
    setOpen,
    selectedImages,
    apiHandler,
    externalStyle = {}
}) => {


    if (!open) {
        return null;
    };

    const getDialogStyle = () => {
        return {
            ...styles.dialogStyle,
            ...externalStyle
        };
    };

    const handleConfirm = async () => {
        try {
            await apiHandler();
            setOpen(false);
        }
        catch (error) {
            console.warn(error);
        };
    };

    const handleCancel = () => {
        setOpen(false);
    }

    const getBlobUrlFromFile = (file) => {
        const blob = new Blob([file], { type: file.type });

        const url = URL.createObjectURL(blob);

        return url;
    };

    return (
        <div
            style={styles.overlay}
            onClick={() => setOpen(false)}
        >
            <dialog
                open={open}
                style={getDialogStyle()}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    onClick={() => setOpen(false)}
                    style={styles.closeIconContainer}
                >
                    <CloseModalIconSVG />
                </div>


                <div style={styles.bodyContainer}>
                    <div style={styles.imagesContainer}>
                        {selectedImages.length && selectedImages.map((image) => {
                            return (
                                <div style={styles.singleImageContainerStyle}>
                                    <img
                                        style={styles.imageStyle}
                                        src={getBlobUrlFromFile(image)}
                                    />
                                </div>
                            );
                        })}
                    </div>

                    <div style={styles.buttonsContainer}>
                        <BaseButton
                            onClick={() => handleCancel()}
                            variant={ButtonVariantEnum.WHITE}
                            text={"Odustani"}
                        />

                        <BaseButton
                            onClick={() => handleConfirm()}
                            variant={ButtonVariantEnum.BLACK}
                            text={"Sačuvaj"}
                        />
                    </div>
                </div>

            </dialog>
        </div>
    );
};

export default AddImagesModal;

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
    },
    dialogStyle: {
        border: "none",
        borderRadius: "8px",
        paddingTop: "40px",
        paddingBottom: "80px",
        paddingInline: "20px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    closeIconContainer: {
        cursor: "pointer",
        position: "absolute",
        top: 10,
        right: 16,
    },
    bodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 40,
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    imagesContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 20
    },
    singleImageContainerStyle: {
        width: 250,
        height: 250,
        overflow: "hidden"
    },
    imageStyle: {
        width: "100%",
        height: "100%",
        objectFit: "cover"
    },
    buttonsContainer: {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        gap: 20
    }
}